<template>
    <CollapsibleWidget v-if="options.length > 0">
        <template #name>Master Template Size</template>

        <template #controls />

        <CheckboxGroup v-model="selectedValues" class="editable-group__values" :vertical="true">
            <Checkbox v-for="option in options" :key="option" :label="option" />
        </CheckboxGroup>
    </CollapsibleWidget>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

import { deepClone } from "@/utils";
import { FilterType, MasterTemplateLibraryAction } from "@/store/modules/masterTemplateLibrary";
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";

export default defineComponent({
    name: "MasterTemplateSizeFilter",
    components: { CollapsibleWidget },

    props: {
        campaignMasterTemplateIds: {
            type: Array as PropType<string[]>,
            default() {
                return [];
            }
        }
    },

    computed: {
        filterValues() {
            return this.$store.state.masterTemplateLibrary.filters.filter(filter => filter.type === FilterType.Size);
        },

        masterTemplates() {
            return this.$store.state.masterTemplateLibrary.masterTemplates;
        },

        // Templates that belong to the client but has not been added to the campaign yet.
        masterTemplateIds() {
            return this.$store.state.masterTemplateLibrary.masterTemplateIds.filter(
                templateId => !this.campaignMasterTemplateIds.includes(templateId)
            );
        },

        options() {
            return Object.keys(
                this.masterTemplateIds.reduce(
                    (acc, cur) =>
                        Object.assign(acc, {
                            [`${this.masterTemplates[cur].width}x${this.masterTemplates[cur].height}`]: true
                        }),
                    [] as string[]
                )
            );
        },

        selectedValues: {
            get() {
                if (this.filterValues.length) {
                    const filterValuesCopy = deepClone(this.filterValues);

                    return filterValuesCopy.pop()?.values;
                }

                return [];
            },
            set(newValue: string[]) {
                this.$store.dispatch(MasterTemplateLibraryAction.UpdateSizeFilter, {
                    values: newValue
                });
            }
        }
    },

    beforeUnmount() {
        this.selectedValues = [];
    }
});
</script>

<style lang="scss">
.editable-group {
    .show-form--showing {
        display: none;
    }
}

.editable-group__add {
    width: 100%;
}

.editable-group__values {
    width: 100%;
}
</style>
